import { render, staticRenderFns } from "./SSOError.vue?vue&type=template&id=51f1b0ae&scoped=true"
import script from "./SSOError.vue?vue&type=script&lang=js"
export * from "./SSOError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1b0ae",
  null
  
)

export default component.exports